export const IDLE = "IDLE";
export const PENDING = "PENDING";
export const FULFILLED = "FULFILLED";
export const REJECTED = "REJECTED";



// WEBPACK FOOTER //
// ./src/constants/Status.js